import React from 'react';
import { Link } from '../link';
import { StyledOrderedList } from '../styled/styledOrderedList';
import { StyledListItem } from '../styled/styledListItem';
import { ArrowRightShortIcon } from '../../icons/arrowRightShort';
import { LinkProps } from '../link/model';
import { useTheme } from '../../hooks/useTheme';
import { BreadcrumbsSchema } from './components/schema';
import { BreadcrumbsProps } from './model';

export * from './model';
export * from './context';

export const BREADCRUMBS_MIN_ITEMS_COUNT_TO_DISPLAY = 2;

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ onClick, items, sx, LinkComponent = Link }) => {
  const theme = useTheme();
  if (items.length < BREADCRUMBS_MIN_ITEMS_COUNT_TO_DISPLAY) {
    return null;
  }

  return (
    <React.Fragment>
      <StyledOrderedList onClick={onClick} sx={{ display: 'inline-flex', flexDirection: 'row', flexWrap: 'wrap', ...sx }}>
        {items.map(({ path, label: _label }, index) => {
          const isLast = index === items.length - 1;
          let label: React.ReactNode = _label;

          if (!isLast) {
            label = (
              <React.Fragment>
                {label}
                <ArrowRightShortIcon sx={{ fontSize: '1rem', ml: 0.5 }} />
              </React.Fragment>
            );
          }

          const linkProps: LinkProps = {
            href: isLast ? undefined : path,
            underline: false,
            sx: {
              color: theme.palette[isLast ? 'brand pink' : 'gray'],
              cursor: isLast ? undefined : 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              // eslint-disable-next-line @typescript-eslint/no-magic-numbers
              mr: isLast ? undefined : 0.5,

              ...(!isLast && {
                transition: theme.transitions.create(['color'], {
                  duration: theme.transitions.duration.short,
                }),
                '@media (pointer: fine)': {
                  '&:hover': {
                    color: theme.palette['brand gray'],
                  },
                },
              }),
            },
          };

          return (
            <StyledListItem key={_label}>
              <LinkComponent {...linkProps}>{label}</LinkComponent>
            </StyledListItem>
          );
        })}
      </StyledOrderedList>
      <BreadcrumbsSchema items={items} />
    </React.Fragment>
  );
};
